import React, { useState, useEffect, memo, useCallback, useContext, useMemo, useRef } from 'react';
import { Formik, useFormik } from 'formik';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Textarea from '../../bootstrap/forms/Textarea';
import Label from '../../bootstrap/forms/Label';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import Select from '../../bootstrap/forms/Select';
import masks, { unmask } from '../../../helpers/utils/masks';
import Wizard, { WizardItem } from '../../Wizard';
import Avatar from '../../MyCustom/Avatar';
import Button from '../../bootstrap/Button';
import Popovers from '../../bootstrap/Popovers';
// DataBase
import ProductDB from '../../../database/wrappers/product';
import CategoryComplementDB from '../../../database/wrappers/categoryComplement';
import Money from '../../../helpers/utils/money/money';
import { Timestamp, where, orderBy } from 'firebase/firestore';
import { DefaultContext } from '../../../contexts/default';
import PreAlert from '../../../helpers/utils/preAlert';
import SuggestionDB from '../../../database/wrappers/suggestion';
import { inputOnlyNumbersNoStitch } from '../../../utils/input';
import ProductsAutoFill from '../ProductsAutoFill/ProductsAutoFill';
import Icon from '../../icon/Icon';
import UserHistory from '../../../database/wrappers/userHistory';
import FiscalGroupDB from '../../../database/wrappers/fiscalGroup';
import InsumosDB from '../../../database/wrappers/insumos';
import { arraysIguais, convertGramaToKg, getCompatibleUnits } from '../../../utils/cmv/convertQtd';

import tabela_ncm from '../../../utils/fiscal/nfce/tabela_ncm.json';
import tabela_cest from '../../../utils/fiscal/nfce/tabela_cest.json';
import tabela_cfop from '../../../utils/fiscal/nfce/tabela_cfop.json';
const officialCESTCodes = tabela_cest.map(item =>
  item.CEST.replace(/\D/g, '')
);

const officialCFOPCodes = tabela_cfop.map(item =>
  item.cfop.replace(/\D/g, '')
);

const officialNCMCodes = (tabela_ncm).Nomenclaturas.map((item) =>
  item.Codigo.replace(/\D/g, '')
);
const genericCEST = ['0000000'];

const validCST = [
  '00', '10', '20', '30', '40', '41', '50', '51', '60', '70', '90'
];

const validate = (values) => {
  const errors = {};

  if (values.fiscal_data_pRedICMS !== '') {
    const pRedICMS = Number(String(values.fiscal_data_pRedICMS).replace(',', '.'));
    if (!Number.isFinite(pRedICMS) || pRedICMS < 0 || pRedICMS > 100) {
      errors.fiscal_data_pRedICMS = 'Informe um percentual entre 0 e 100';
    }
  }

  if (!values.name) {
    errors.name = 'Este campo é necessário';
  }

  if (!values.active) {
    errors.active = 'Você precisa escolher o status do produto'
  }

  const price = unmask(values.price);
  if (!values.price) {
    errors.price = 'Este campo é necessário';
  } else if (isNaN(Number(price)) || Number(price) < 0) {
    errors.price = 'O preço precisa ser um número válido e positivo';
  }

  if (!values.unit) {
    errors.unit = 'Este campo é necessário';
  }

  if (values.myTapp && values.myTappMl === '') {
    errors.myTappMl = 'Este campo é necessário';
  }

  // if (isNaN(Number(values.order)) || Number(values.order) < 0 || Number(values.order) > 99) {
  //   errors.order = "Informe um número entre 0 e 99";
  // }

  // Informações de Produto Composto
  // if (values.type_compound.includes('check')) {
  //   if (isNaN(Number(values.product_qtd)) || Number(values.product_qtd) < 0) {
  //     errors.product_qtd = 'A quantidade precisa ser um número válido';
  //   }

  //   if (Number(values.product_unit_value) < 0) {
  //     errors.product_unit_value = 'O valor precisa ser um número válido';
  //   }
  // }

  // Informaçoes Fiscais
  // if (!values.fiscal_data_bar_code) {
  //   errors.fiscal_data_bar_code = 'Este campo é necessário';
  // }
  if (!values.fiscal_data_ncm) {
    errors.fiscal_data_ncm = 'Este campo é necessário';
  }

  if (!officialNCMCodes.includes(values.fiscal_data_ncm) && !['00000000'].includes(values.fiscal_data_ncm)) {
    errors.fiscal_data_ncm = 'NCM inexistente';
  }
  if (!values.fiscal_data_cst) {
    errors.fiscal_data_cst = 'Este campo é necessário';
  }

  if (!validCST.includes(values.fiscal_data_cst)) {
    errors.fiscal_data_cst = 'CST inexistente';
  }

  if (!officialCFOPCodes.includes(values.fiscal_data_cfop)) {
    errors.fiscal_data_cfop = 'CFOP Inexistente';
  }

  if (!officialCESTCodes.includes(values.fiscal_data_cest) && !genericCEST.includes(values.fiscal_data_cest)) {
    errors.fiscal_data_cest = 'CEST Inexistente';
  }

  if (!values.fiscal_data_cfop) {
    errors.fiscal_data_cfop = 'Este campo é necessário';
  }

  const fiscalGroupsByState = Array.isArray(values.fiscal_groups_by_state) ? values.fiscal_groups_by_state : []
  const seenStates = new Map()
  fiscalGroupsByState.forEach((item, index) => {
    const state = item?.state
    const fiscalGroupId = item?.fiscal_group_id

    if ((state && !fiscalGroupId) || (!state && fiscalGroupId)) {
      if (!Array.isArray(errors.fiscal_groups_by_state)) errors.fiscal_groups_by_state = []
      errors.fiscal_groups_by_state[index] = {
        ...(errors.fiscal_groups_by_state[index] || {}),
        ...(state && !fiscalGroupId ? { fiscal_group_id: 'Selecione o grupo fiscal' } : {}),
        ...(!state && fiscalGroupId ? { state: 'Selecione o estado' } : {}),
      }
    }

    if (!state) return

    if (seenStates.has(state)) {
      const firstIndex = seenStates.get(state)
      if (!Array.isArray(errors.fiscal_groups_by_state)) errors.fiscal_groups_by_state = []
      errors.fiscal_groups_by_state[firstIndex] = { ...(errors.fiscal_groups_by_state[firstIndex] || {}), state: 'Estado já selecionado em outra linha' }
      errors.fiscal_groups_by_state[index] = { ...(errors.fiscal_groups_by_state[index] || {}), state: 'Estado já selecionado em outra linha' }
      return
    }
    seenStates.set(state, index)
  })

  return errors;
}

const _selectUnit = [
  { value: 'KG', text: 'KG' },
  { value: 'UN', text: 'UN' },
  { value: 'L', text: 'L' },
  { value: 'ML', text: 'ML' },
  { value: 'G', text: 'G' },
  { value: 'PC', text: 'PC' },
]

const _selectBrazilStates = [
  { value: 'AC', text: 'AC' },
  { value: 'AL', text: 'AL' },
  { value: 'AP', text: 'AP' },
  { value: 'AM', text: 'AM' },
  { value: 'BA', text: 'BA' },
  { value: 'CE', text: 'CE' },
  { value: 'DF', text: 'DF' },
  { value: 'ES', text: 'ES' },
  { value: 'GO', text: 'GO' },
  { value: 'MA', text: 'MA' },
  { value: 'MT', text: 'MT' },
  { value: 'MS', text: 'MS' },
  { value: 'MG', text: 'MG' },
  { value: 'PA', text: 'PA' },
  { value: 'PB', text: 'PB' },
  { value: 'PR', text: 'PR' },
  { value: 'PE', text: 'PE' },
  { value: 'PI', text: 'PI' },
  { value: 'RJ', text: 'RJ' },
  { value: 'RN', text: 'RN' },
  { value: 'RS', text: 'RS' },
  { value: 'RO', text: 'RO' },
  { value: 'RR', text: 'RR' },
  { value: 'SC', text: 'SC' },
  { value: 'SP', text: 'SP' },
  { value: 'SE', text: 'SE' },
  { value: 'TO', text: 'TO' },
]

const ModalRegisterProducts = ({ open, setIsOpen, setIsClose, productSelected }) => {

  const { establishment, onShowAlert, settings, user } = useContext(DefaultContext)

  const [isLoading, setIsLoading] = useState(false);
  const [productsResponse, setProductsResponse] = useState([]);
  const [categoryComplementsResponse, setCategoryComplementsResponse] = useState([]);
  const [fiscalGroups, setFiscalGroups] = useState([]);
  // Array abaixo é utilizado para armazenar os dados do produto que está compondo o combo quando type_compound for check
  const [productsToCompound, setProductsToCompound] = useState([])
  const [suggestions, setsuggestions] = useState([])

  //gerenciamento de insumos
  const [insumes, setInsumes] = useState([])
  const [insumeToProduct, setInsumeToProduct] = useState([])
  const [insumesIntial, setInsumesIntial] = useState([])
  const isMounted = useRef(true)

  useEffect(() => () => {
    isMounted.current = false
  }, [])

  useEffect(() => {
    if (!establishment) return;
    return new FiscalGroupDB(establishment.id).on(setFiscalGroups, orderBy('name', 'asc'));
  }, [establishment])

  useEffect(() => {
    if (!open) {
      setInsumeToProduct([])
      setProductsToCompound([])
      return formik.resetForm();
    }
    if (productSelected) {
      const {
        active,
        category_complements,
        suggestionId,
        classification,
        complements,
        eat_here,
        customization,
        eat_out,
        order,
        orderDelivery,
        myTapp,
        myTappMl,
        fiscal_data,
        highlights,
        image_url,
        name,
        description,
        price,
        products,
        type_compound,
        ignoreFiscal,
        unit,
        classifications,
        banner_url,
        internalCode,
        externalCode,
        delivery_code,
        insumes,
        type_insume,
        fiscal_groups_by_state
      } = productSelected;

      setInsumesIntial(insumes !== undefined ? insumes : [])
      setInsumeToProduct(insumes !== undefined ? insumes : []);
      setProductsToCompound(products)

      formik.setValues({
        image_url: image_url ?? null,
        banner_url: banner_url ?? null,
        name: name,
        description,
        active: active ? 'ativo' : 'inativo',
        price: Money.centsToCoin(price).toFixed(2),
        unit: unit,
        order: Number(order),
        orderDelivery: Number(orderDelivery),
        type_compound: type_compound ? ['check'] : [],
        type_insume: type_insume ? ['check'] : [],
        ignoreFiscal: ignoreFiscal ? ['check'] : [],
        category_complements: category_complements ? ['check'] : [],
        highlights: highlights ? ['check'] : [],
        suggestionId: suggestionId || 'x',
        classification: classification,
        internalCode: internalCode || '',
        externalCode: externalCode || '',
        classifications: classifications ? classifications : [],
        eat_here: eat_here,
        customizable: customization ? customization?.customizable : false,
        customizablePrice: customization ? Money.centsToCoin(customization?.customizablePrice).toFixed(2) : 0,
        customizableColor: customization ? customization?.customizableColor : '#FFFFFF',
        eat_out: eat_out,
        order,
        myTapp: myTapp === undefined ? false : myTapp,
        myTappMl: myTappMl === undefined ? '' : myTappMl.toString(),

        complements: complements,
        fiscal_groups_by_state: Array.isArray(fiscal_groups_by_state) && fiscal_groups_by_state.length > 0
          ? fiscal_groups_by_state
          : [{ state: '', fiscal_group_id: '' }],
        delivery_code: delivery_code || null,

        // fiscal data
        fiscal_data_pis: fiscal_data?.pis ?? '',
        fiscal_data_cofins: fiscal_data?.cofins ?? '',
        fiscal_data_cBenef: fiscal_data?.cBenef ?? '',
        fiscal_data_cClassTrib: fiscal_data?.cClassTrib ?? '',
        fiscal_data_cst_cbs_ibs: fiscal_data?.cst_cbs_ibs ?? '',
        fiscal_data_percentualReducao: fiscal_data?.percentualReducao ?? '',
        fiscal_data_pRedICMS: fiscal_data?.pRedICMS ?? '',
        fiscal_data_bar_code: fiscal_data?.bar_code ?? '',
        fiscal_data_ncm: fiscal_data?.ncm,
        fiscal_data_cst: fiscal_data?.cst,
        fiscal_data_csosn: fiscal_data?.csosn,
        fiscal_data_cest: fiscal_data?.cest,
        fiscal_data_cfop: fiscal_data?.cfop,
        fiscal_data_tributary_situation: fiscal_data?.tributary_situation,
        fiscal_data_aliq_icms: fiscal_data?.aliq_icms || '',
        fiscal_data_sku: fiscal_data?.sku || '',

        // propriedades acima: antes de enviar para o backend montar um objeto chamado fiscal_data
      });
    }
  }, [productSelected, open])

  // Pega os produtos
  useEffect(() => {
    if (establishment) {
      function sort(a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      }
      async function getCategoriesComplements() {
        const categoryComplements = await new CategoryComplementDB(establishment.id).getAll(where('active', '==', true))
        categoryComplements.sort(sort);
        setCategoryComplementsResponse(categoryComplements)
      }
      async function getSuggestions() {
        const suggestions = await new SuggestionDB(establishment.id).getAll(where('active', '==', true))
        suggestions.sort(sort);
        setsuggestions(suggestions)
      }

      getCategoriesComplements();
      getSuggestions();
      const onSubscribe = new ProductDB(establishment.id).on(setProductsResponse, where('active', '==', true));
      const onSubscribe1 = new InsumosDB(establishment.id).on(setInsumes);
      return () => {
        onSubscribe()
        onSubscribe1()
      }
    }
  }, [establishment])

  const { listedInsumes, noListedInsumes } = useMemo(() => {
    const listed = [];
    const notListed = [];

    insumes.forEach(insume => {
      const isAdded = insumeToProduct.some(productInsume => productInsume.insume === insume.id);
      if (isAdded) {
        listed.push(insume);
      } else {
        notListed.push(insume);
      }
    });

    const sortByName = (a, b) =>
      a.text.localeCompare(b.text);

    return {
      listedInsumes: listed
        .map(item => ({ value: item.id, text: item.name, unit: item.unit }))
        .sort(sortByName),
      noListedInsumes: notListed
        .map(item => ({ value: item.id, text: item.name, unit: item.unit }))
        .sort(sortByName),
    };
  }, [insumes, insumeToProduct]);

  const formik = useFormik({
    initialValues: {
      id: '',
      image: null,
      image_url: null,
      banner: null,
      banner_url: null,
      name: '',
      active: '',
      price: '',
      unit: '',
      description: '',
      type_compound: [],

      ignoreFiscal: [],
      category_complements: [],
      suggestions: null,
      suggestionId: 'x',
      highlights: [],
      order: '',
      orderDelivery: '',
      classification: '',
      internalCode: '',
      externalCode: '',
      eat_here: false,
      customizable: false,
      customizablePrice: '',
      customizableColor: '',
      eat_out: false,
      myTapp: false,
      myTappMl: '',


      insume_qtd: '',
      insume_unit: '',
      insume: '',
      insumes: [],
      type_insume: [],

      // products
      product_qtd: '',
      product_unit: '',
      product_unit_value: '',
      product: '',
      productPrint: false,
      // propriedades acima: antes de enviar para o backend montar um array de objetos

      complements: [], //Categoria de Complementos
      productsAux: {},
      classifications: [],
      fiscal_groups_by_state: [{ state: '', fiscal_group_id: '' }],
      delivery_code: '',


      // fiscal data
      fiscal_data_bar_code: '',
      fiscal_data_ncm: '',
      fiscal_data_cst: '',
      fiscal_data_csosn: '',
      fiscal_data_cest: '',
      fiscal_data_cfop: '',
      fiscal_data_aliq_icms: '',
      fiscal_data_tributary_situation: '',
      fiscal_data_sku: '',
      fiscal_data_pis: '',
      fiscal_data_cofins: '',
      fiscal_data_cBenef: '',
      fiscal_data_cClassTrib: '',
      fiscal_data_percentualReducao: '',
      fiscal_data_pRedICMS: '',
      fiscal_data_cst_cbs_ibs: '',
      // propriedades acima: antes de enviar para o backend montar um objeto chamado fiscal_data

    },
    validate: validate,
    onSubmit: values => {
      const {
        name,
        active,
        price,
        unit,
        type_compound,
        type_insume,
        ignoreFiscal,
        category_complements,
        suggestionId,
        image,
        banner,
        highlights,
        classification,
        classifications,
        eat_here,
        customizable,
        customizablePrice,
        customizableColor,
        eat_out,
        myTapp,
        order,
        orderDelivery,
        myTappMl,
        description,
        complements,
        fiscal_groups_by_state,
        internalCode,
        externalCode,
        delivery_code,
        insumes,

        // fiscal data
        fiscal_data_pis,
        fiscal_data_cofins,
        fiscal_data_cBenef,
        fiscal_data_bar_code,
        fiscal_data_cClassTrib,
        fiscal_data_percentualReducao,
        fiscal_data_pRedICMS,
        fiscal_data_cst_cbs_ibs,
        fiscal_data_ncm,
        fiscal_data_cst,
        fiscal_data_csosn,
        fiscal_data_cest,
        fiscal_data_cfop,
        fiscal_data_aliq_icms,
        fiscal_data_tributary_situation,
        fiscal_data_sku,
        // propriedades acima: antes de enviar para o backend montar um objeto chamado fiscal_data
      } = values

      const price_unmasked = unmask(price)
      const customizationPrice = unmask(customizablePrice)

      const products = type_compound.includes('check') && productsToCompound ? productsToCompound.map(item => ({
        name: item.name,
        qtd: Number(item.qtd),
        unit: item.unit,
        unit_value: Number(unmask(item.unit_value)),
        product: item.product,
        productPrint: item.productPrint ?? false,
      })) : [];

      const insumesData = type_insume.includes('check') && insumeToProduct ? insumeToProduct?.map(item => ({
        insume: item.insume,
        name: item.name,
        qtd: Number(item.qtd),
        unit: item.unit,
      })) : [];

      const arrayInsumeDiff = arraysIguais(insumesData, insumesIntial)

      const fiscal_data = {
        cofins: fiscal_data_cofins ?? '',
        pis: fiscal_data_pis ?? '',
        cBenef: fiscal_data_cBenef ?? '',
        cClassTrib: fiscal_data_cClassTrib ?? '',
        cst_cbs_ibs: fiscal_data_cst_cbs_ibs ?? '',
        percentualReducao: fiscal_data_percentualReducao ?? '',
        pRedICMS: String(fiscal_data_pRedICMS ?? '').replace(',', '.'),
        bar_code: fiscal_data_bar_code ?? '',
        ncm: fiscal_data_ncm ?? '',
        cst: fiscal_data_cst ?? '',
        csosn: fiscal_data_csosn ?? '',
        cest: fiscal_data_cest ?? '',
        cfop: fiscal_data_cfop ?? '',
        aliq_icms: String(fiscal_data_aliq_icms ?? '').replace(',', '.'),
        tributary_situation: fiscal_data_tributary_situation ?? '',

        sku: fiscal_data_sku ?? ''
      };

      const fiscal_groups_by_state_payload = (Array.isArray(fiscal_groups_by_state) ? fiscal_groups_by_state : [])
        .filter((item) => item?.state && item?.fiscal_group_id)
        .map((item) => ({ state: item.state, fiscal_group_id: item.fiscal_group_id }));


      const data = {
        image: image === undefined ? null : image,
        banner: banner === undefined ? null : banner,
        name,
        description: description ?? '',
        active: active === 'ativo',
        price: Number(price_unmasked),
        unit,
        type_compound: type_compound.includes('check'),
        type_insume: type_insume.includes('check'),
        ignoreFiscal: ignoreFiscal.includes('check'),
        category_complements: category_complements.includes('check'),
        suggestionId: suggestionId === 'x' ? null : suggestionId,
        highlights: highlights.includes('check'),
        classification: classification ?? '',
        internalCode: internalCode || '',
        externalCode: externalCode || '',
        classifications: classifications ?? [],
        eat_here: eat_here ?? false,
        customization: {
          customizable,
          customizablePrice: Number(customizationPrice),
          customizableColor,
        },
        eat_out: eat_out ?? false,
        myTapp: myTapp ?? false,
        myTappMl: Number(myTappMl),
        products,
        insumes: insumesData,
        complements: category_complements.includes('check') ? (complements || []) : [],
        fiscal_groups_by_state: fiscal_groups_by_state_payload,
        fiscal_data,
        order: order ? Number(order) : null,
        orderDelivery: orderDelivery ? Number(orderDelivery) : null,
        delivery_code: delivery_code ?? '',
        ...(!arrayInsumeDiff && { lastInsumeModified: Timestamp.now() })
      }

      const onSuccess = () => {
        onShowAlert(PreAlert.success('Registro cadastrado com sucesso'))
        setIsClose();
      }
      const onSuccessUpdate = () => {
        onShowAlert(PreAlert.success('Registro atualizado com sucesso'))
        setIsClose();
      }
      const onError = (error) => {
        console.error('Falhou ao salvar o produto:', error)
        onShowAlert(PreAlert.error(error?.message || error || 'Falhou ao cadastrar o registro'))
      }
      setIsLoading(true)
      if (productSelected) {
        new ProductDB(establishment.id)
          .update(productSelected.id, data)
          .then(() => {
            onSuccessUpdate();
            new UserHistory(establishment.id, user, "o Produto")
              .update(productSelected.id, { data, selected: productSelected })
              .finally(() => { })
          })
          .catch(onError)
          .finally(() => isMounted.current && setIsLoading(false))
      } else {
        new ProductDB(establishment.id)
          .create(data)
          .then(() => {
            onSuccess();
            new UserHistory(establishment.id, user, "o Produto")
              .create(data)
              .finally(() => { })
          })
          .catch(onError)
          .finally(() => isMounted.current && setIsLoading(false))
      }
    },
  });

  const handleChangeOrder = useCallback(e => {
    const order = e.target.value.replace(/\D/g, "");
    formik.setValues({
      ...formik.values,
      order
    })
  }, [formik.values])

  const checkStepIsValid = (step) => {
    if (step === 'step1') {
      if (
        formik.values.name !== '' &&
        formik.values.active !== '' &&
        formik.values.price !== '' &&
        formik.values.unit !== ''
      ) {
        return false;
      } else {
        return true;
      }
    }
    if (step === 'add_product') {
      if (
        formik.values.product_qtd !== '' &&
        formik.values.product_unit !== '' &&
        formik.values.product_unit_value !== '' &&
        formik.values.product !== ''
      ) {
        return false;
      } else {
        return true;
      }
    }
    if (step === 'add_insumo') {
      if (
        formik.values.insume_qtd !== '' &&
        formik.values.insume_unit !== ''
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  const productDicionary = useMemo(() => {
    const productDicionary = {}
    productsResponse.forEach(item => productDicionary[item.id] = item)
    return productDicionary;
  }, [productsResponse])
  const productsNoCombo = useMemo(() => productsResponse.filter(prod => prod.type_compound === false), [productsResponse])
  const productsNoComboOption = useMemo(() => productsNoCombo.map(item => ({ value: item.id, text: item.name })), [productsNoCombo])

  const handleAddProductsToCompound = () => {
    if (
      !formik.values.product_qtd ||
      isNaN(Number(formik.values.product_qtd)) ||
      !formik.values.product_unit ||
      !formik.values.product_unit_value ||
      !formik.values.product
    ) return;
    setProductsToCompound([...productsToCompound,
    {
      qtd: formik.values.product_qtd,
      unit: formik.values.product_unit,
      unit_value: unmask(formik.values.product_unit_value),
      name: productsNoComboOption.find(item => item.value === formik.values.product)?.text || '',
      product: formik.values.product,
      productPrint: formik.values.productPrint,

    }
    ])
    formik.setFieldValue('product_qtd', '')
    formik.setFieldValue('product_unit', '')
    formik.setFieldValue('product_unit_value', '')
    formik.setFieldValue('product', '')
    formik.setFieldValue('productPrint', false)
  }

  const handleAddInsumeToProduct = () => {
    if (
      !formik.values.insume_qtd ||
      !formik.values.insume ||
      !formik.values.insume_unit


    ) return;
    setInsumeToProduct([...insumeToProduct,
    {
      qtd: formik.values.insume_qtd,
      unit: formik.values.insume_unit || 'UN',
      name: insumes.find(item => item.id === formik.values.insume)?.name || '',
      insume: formik.values.insume,
      isNew: true
    }
    ])
    formik.setFieldValue('insume_qtd', '')
    formik.setFieldValue('insume_value', '')
    formik.setFieldValue('insume', '')
    formik.setFieldValue('insume_unit', '')

  }

  const handleRemoveProductsToCompound = (index) => {
    const newProductsToCompound = productsToCompound.filter((item, i) => i !== index)
    setProductsToCompound(newProductsToCompound)
  }

  const handleRemoveInsume = (index) => {
    const newInsumes = insumeToProduct.filter((item, i) => i !== index)
    setInsumeToProduct(newInsumes)
  }

  const handleAddFiscalGroupByState = useCallback(() => {
    const current = Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : []
    const usedStates = [...new Set(current.map((i) => i?.state).filter(Boolean))]
    if (usedStates.length >= _selectBrazilStates.length) return
    formik.setValues({
      ...formik.values,
      fiscal_groups_by_state: [...current, { state: '', fiscal_group_id: '' }],
    })
  }, [formik.values])

  const handleRemoveFiscalGroupByState = useCallback((index) => {
    const current = Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : []
    if (current.length <= 1) {
      formik.setValues({
        ...formik.values,
        fiscal_groups_by_state: [{ state: '', fiscal_group_id: '' }],
      })
      return
    }

    const next = current.filter((_, i) => i !== index)
    formik.setValues({
      ...formik.values,
      fiscal_groups_by_state: next.length > 0 ? next : [{ state: '', fiscal_group_id: '' }],
    })
  }, [formik.values])

  const handleImage = useCallback((e) => {
    const [file] = Array.from(e.target.files)
    formik.setValues({
      ...formik.values,
      image: file,
      image_url: URL.createObjectURL(file)
    })
  }, [formik.values])

  const handleBanner = useCallback((e) => {
    const [file] = Array.from(e.target.files)
    formik.setValues({
      ...formik.values,
      banner: file,
      banner_url: URL.createObjectURL(file)
    })
  }, [formik.values])

  const HeaderComplements = useMemo(() => (
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <p>#</p>
      </div>
      <div className='col-md-3'>
        <p>Nome</p>
      </div>
      <div className='col-md-4'>
        <p>Descrição</p>
      </div>
      <div className='col-md-2'>
        <p>Mínimo</p>
      </div>
      <div className='col-md-2'>
        <p>Maxímo</p>
      </div>
    </div>
  ), [])

  const optionsFiscalGroups = useMemo(
    () => [
      { value: '', text: 'Selecione o grupo fiscal' },
      ...fiscalGroups.map((group) => ({ value: group.id, text: group.name })),
    ],
    [fiscalGroups],
  )
  const optionsSuggestion = useMemo(() => {
    const options = suggestions.map(item => ({ value: item.id, text: item.name }))
    options.unshift({ value: 'x', text: 'Nenhuma' })
    return options;
  }, [suggestions])

  const showInsumesStep = formik.values?.type_insume?.includes('check')
  const showCompoundStep = formik.values?.type_compound?.includes('check')
  const showComplementsStep = formik.values?.category_complements?.includes('check')
  const onChangeNumbersNoStitch = useCallback((e) => inputOnlyNumbersNoStitch(formik, e), [formik])

  async function getImageFileFromUrl(imageUrl) {
    const response = await fetch(imageUrl)
    const blob = await response.blob()
    const filename = imageUrl.split('/').pop()
    return new File([blob], filename)
  }

  function onChosenProduct(product) {
    async function updateFormik() {
      await formik.setFieldValue('name', product.name)
      await formik.setFieldValue('unit', product.unit)
      formik.setFieldTouched('name', true, true)
      formik.setFieldTouched('unit', true, true)

      const imageFile = await getImageFileFromUrl(product.image)
      await formik.setFieldValue('image_url', product.image || null)
      await formik.setFieldValue('image', imageFile)
    }

    updateFormik()
  }


  return (
    <Modal
      id={'modal-register-products'}
      titleId={'Cadastro de Produtos'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={true}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl'
      isAnimation={true}
    >
      <ModalHeader className='p-4 mt-2 justify-content-start' setIsOpen={setIsOpen}>
        <ModalTitle id="register-procuts">{productSelected ? 'Atualização de Produtos' : 'Cadastro de Produtos'}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Wizard
          isHeader
          color='info'
          onSubmit={formik.handleSubmit}
          className='p-4 m-0'
          isLoading={isLoading}
        >
          <WizardItem id='step1' title='Informações do Produto' required={checkStepIsValid('step1')}>
            {/* Imagem do Produto */}
            <div className='d-flex align-items-center justify-content-center gap-5'>
              <FormGroup
                id='image_url'
                ariaLabel='Logo'
                className='row justify-content-center'
              >
                <>
                  <label className='text-center mb-3'>Foto do produto</label>
                  <Avatar
                    id='image_url'
                    value={formik.values.image_url}
                    onChange={handleImage} />
                </>
              </FormGroup>

              <FormGroup
                id='image_url'
                ariaLabel='Logo'
                className='row justify-content-center'
              >
                <>
                  <label className='text-center mb-3'>Banner do produto</label>
                  <Avatar
                    id='banner_url'
                    value={formik.values.banner_url}
                    onChange={handleBanner} />
                </>
              </FormGroup>
            </div>
            {/* Dados */}
            < div className="row  pb-2 d-flex">
              {/* Nome */}
              <FormGroup id="name" label="Nome" className='col-md-6 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  isValid={formik.isValid}
                  isTouched={formik.touched.name}
                  invalidFeedback={formik.errors.name}
                  validFeedback='Assim está bom!'
                  placeholder='Copo de vidro, garrafa, etc.'
                />
              </FormGroup>
              <div className='col-md-6 mb-4'>
                <Label htmlFor='active'>Status</Label>
                <ChecksGroup
                  className='d-flex gap-4 align-items-center'
                  style={{ minHeight: 38 }}
                  isValid={formik.isValid}
                  isTouched={formik.touched.active}
                  invalidFeedback={formik.errors.active}
                >
                  <Checks
                    type="radio"
                    id="active"
                    label="Ativo"
                    name="active"
                    value="ativo"
                    onChange={formik.handleChange}
                    checked={formik.values.active}
                    isInline
                    className='me-1'
                  />
                  <Checks
                    type="radio"
                    id="active2"
                    label="Inativo"
                    name="active"
                    value="inativo"
                    onChange={formik.handleChange}
                    checked={formik.values.active}
                    isInline
                    className='me-1'
                  />
                </ChecksGroup>
              </div>
              <ProductsAutoFill searchQuery={formik.values.name} onChosenProduct={onChosenProduct} />

              <FormGroup id="description" label="Descrição" className='col-md-12 mb-4'>
                <Textarea
                  rows={3}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.description}
                  isValid={formik.isValid}
                  isTouched={formik.touched.description}
                  invalidFeedback={formik.errors.description}
                  validFeedback='Assim está bom!'
                  placeholder='Descreva o produto'
                />
              </FormGroup>


              {/* Preço */}
              <FormGroup id='price' label='Preço' className='col-md-3 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={masks.money(formik.values.price)}
                  isValid={formik.isValid}
                  isTouched={formik.touched.price}
                  invalidFeedback={formik.errors.price}
                  validFeedback='Assim está bom!'
                  placeholder='50,00'
                />
              </FormGroup>

              {/* Unit */}
              <FormGroup id='unit' label='Unidade' className='col-md-3 mb-4' >
                <Select
                  placeholder='Selecione o tipo'
                  list={_selectUnit}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.unit}
                  isValid={formik.isValid}
                  isTouched={formik.touched.unit}
                  invalidFeedback={formik.errors.unit}
                />
              </FormGroup>

              {/* Ordem */}
              <FormGroup id="order" label="Ordem de Exibição" className='col-md-3 mb-4'>
                <Input
                  onChange={handleChangeOrder}
                  onBlur={formik.handleBlur}
                  value={formik.values.order || ''}
                  isValid={formik.isValid}
                  isTouched={formik.touched.order}
                  invalidFeedback={formik.errors.order}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 1'
                />
              </FormGroup>
              {/* Sugestão */}
              <FormGroup id='suggestionId' label='Sugestão (Opcional)' className='col-md-3 mb-4'>
                <Select
                  placeholder='Selecione uma sugestão se desejar'
                  list={optionsSuggestion}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.suggestionId}
                  isValid={formik.isValid}
                  isTouched={formik.touched.suggestionId}
                  invalidFeedback={formik.errors.suggestionId}
                />
              </FormGroup>

              <FormGroup id='internalCode' label='Cód Interno' className='col-md-3 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.internalCode}
                  isValid={formik.isValid}
                  isTouched={formik.touched.internalCode}
                  invalidFeedback={formik.errors.internalCode}
                  validFeedback='Assim está bom!'
                  placeholder='00'
                />
              </FormGroup>

              <FormGroup id='externalCode' label='Cód Externo' className='col-md-3 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.externalCode}
                  isValid={formik.isValid}
                  isTouched={formik.touched.externalCode}
                  invalidFeedback={formik.errors.externalCode}
                  validFeedback='Assim está bom!'
                  placeholder='00'
                />
              </FormGroup>

              {/* Ordem Delivery */}
              <FormGroup id="orderDelivery" label="Ordem no Delivey" className='col-md-3 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.orderDelivery || ''}
                  isValid={formik.isValid}
                  isTouched={formik.touched.orderDelivery}
                  invalidFeedback={formik.errors.orderDelivery}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 1'
                />
              </FormGroup>

              {/* Cód Delivery */}
              <FormGroup id="delivery_code" label="Cód Delivery" className='col-md-3 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.delivery_code || ''}
                  isValid={formik.isValid}
                  isTouched={formik.touched.delivery_code}
                  invalidFeedback={formik.errors.delivery_code}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 1'
                />
              </FormGroup>

              <div className='col-md-12 mb-1'>
                <Label className='text-dark fw-bold text-uppercase small mb-0'>Características do produto</Label>
              </div>

              <div className='col-md-4 mb-2'>
                <div className='d-flex align-items-center gap-2 py-1'>
                  {insumes.length > 0 ? (
                    <ChecksGroup
                      isValid={formik.isValid}
                      isTouched={Boolean(formik.touched.type_insume)}
                      invalidFeedback={formik.errors.type_insume}>
                      <Checks
                        type="checkbox"
                        id="type_insume"
                        name="type_insume"
                        value='check'
                        onChange={formik.handleChange}
                        checked={formik.values?.type_insume?.includes('check')}
                        isInline
                        className='me-1'
                      />
                    </ChecksGroup>
                  ) : (
                    <Popovers desc="Sem produtos cadastrados ainda" placement="bottom" trigger="hover">
                      <ChecksGroup>
                        <Checks
                          type="checkbox"
                          isInline
                          disabled={insumes.length === 0}
                          className='me-1'
                        />
                      </ChecksGroup>
                    </Popovers>
                  )}
                  <Label htmlFor='type_insume' className='mb-0 text-dark'>Insumo ?</Label>
                </div>
              </div>

              <div className='col-md-4 mb-2'>
                <div className='d-flex align-items-center gap-2 py-1'>
                  {productsNoCombo.length > 0 ? (
                    <ChecksGroup
                      isValid={formik.isValid}
                      isTouched={Boolean(formik.touched.type_compound)}
                      invalidFeedback={formik.errors.type_compound}>
                      <Checks
                        type="checkbox"
                        id="type_compound"
                        name="type_compound"
                        value='check'
                        onChange={formik.handleChange}
                        checked={formik.values.type_compound.includes('check')}
                        isInline
                        className='me-1'
                      />
                    </ChecksGroup>
                  ) : (
                    <Popovers desc="Sem produtos cadastrados ainda" placement="bottom" trigger="hover">
                      <ChecksGroup>
                        <Checks
                          type="checkbox"
                          isInline
                          disabled={productsResponse.length === 0}
                          className='me-1'
                        />
                      </ChecksGroup>
                    </Popovers>
                  )}
                  <Label htmlFor='type_compound' className='mb-0 text-dark'>Produto Composto?</Label>
                </div>
              </div>

              <div className='col-md-4 mb-2'>
                <div className='d-flex align-items-center gap-2 py-1'>
                  {categoryComplementsResponse.length > 0 ? (
                    <ChecksGroup
                      isValid={formik.isValid}
                      isTouched={Boolean(formik.touched.category_complements)}
                      invalidFeedback={formik.errors.category_complements}>
                      <Checks
                        type="checkbox"
                        id="category_complements"
                        name="category_complements"
                        value='check'
                        onChange={formik.handleChange}
                        checked={formik.values.category_complements.includes('check')}
                        isInline
                        className='me-1'
                      />
                    </ChecksGroup>
                  ) : (
                    <Popovers desc="Sem complementos cadastrados ainda" placement="bottom" trigger="hover">
                      <ChecksGroup>
                        <Checks
                          type="checkbox"
                          isInline
                          disabled={categoryComplementsResponse.length === 0}
                          className='me-1'
                        />
                      </ChecksGroup>
                    </Popovers>
                  )}
                  <Label htmlFor='category_complements' className='mb-0 text-dark'>Complementos?</Label>
                </div>
              </div>

              <div className='col-md-4 mb-2'>
                <div className='d-flex align-items-center gap-2 py-1'>
                  <ChecksGroup isInline>
                    <Checks
                      type="checkbox"
                      id="myTapp"
                      name="myTapp"
                      onChange={formik.handleChange}
                      checked={formik.values.myTapp}
                      className='me-1'
                    />
                  </ChecksGroup>
                  <Label htmlFor='myTapp' className='mb-0 text-dark'>Produtos MyTapp</Label>
                </div>
                {formik.values.myTapp && (
                  <FormGroup id='myTappMl' label='Qtd. (ML)' className='mt-2'>
                    <Input
                      onChange={onChangeNumbersNoStitch}
                      onBlur={formik.handleBlur}
                      value={formik.values.myTappMl}
                      isValid={formik.isValid}
                      isTouched={formik.touched.myTappMl}
                      invalidFeedback={formik.errors.myTappMl}
                      validFeedback='Assim está bom!'
                      placeholder='500'
                    />
                  </FormGroup>
                )}
              </div>

              {!settings?.ecommerce && (
                <>
                  <div className='col-md-4 mb-2'>
                    <div className='d-flex align-items-center gap-2 py-1'>
                      <ChecksGroup isInline>
                        <Checks
                          type="checkbox"
                          id="eat_here"
                          name="eat_here"
                          onChange={formik.handleChange}
                          checked={formik.values.eat_here}
                          className='me-1'
                        />
                      </ChecksGroup>
                      <Label htmlFor='eat_here' className='mb-0 text-dark'>Comer no local</Label>
                    </div>
                  </div>

                  <div className='col-md-4 mb-2'>
                    <div className='d-flex align-items-center gap-2 py-1'>
                      <ChecksGroup isInline>
                        <Checks
                          type="checkbox"
                          id="eat_out"
                          name="eat_out"
                          onChange={formik.handleChange}
                          checked={formik.values.eat_out}
                          className='me-1'
                        />
                      </ChecksGroup>
                      <Label htmlFor='eat_out' className='mb-0 text-dark'>Comer fora</Label>
                    </div>
                  </div>
                </>
              )}

              {settings?.ecommerce && (
                <div className='col-md-4 mb-2'>
                  <div className='d-flex align-items-center gap-2 py-1'>
                    <ChecksGroup isInline>
                      <Checks
                        type="checkbox"
                        id="customizable"
                        name="customizable"
                        onChange={formik.handleChange}
                        checked={formik.values.customizable}
                        className='me-1'
                      />
                    </ChecksGroup>
                    <Label htmlFor='customizable' className='mb-0 text-dark'>E-Commerce?</Label>
                  </div>
                  {formik.values.customizable && (
                    <>
                      <FormGroup id='customizablePrice' label='Preco da personalizacao' className='mt-2'>
                        <Input
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={masks.money(formik.values.customizablePrice)}
                          isValid={formik.isValid}
                          isTouched={formik.touched.customizablePrice}
                          invalidFeedback={formik.errors.customizablePrice}
                          validFeedback='Assim esta bom!'
                          placeholder='50,00'
                        />
                      </FormGroup>
                      <FormGroup id='customizableColor' label='Cor da personalizacao' className='mt-2'>
                        <Input
                          type="color"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.customizableColor}
                          isValid={formik.isValid}
                          isTouched={formik.touched.customizableColor}
                          invalidFeedback={formik.errors.customizableColor}
                          validFeedback='Cor selecionada!'
                          placeholder='#000000'
                        />
                      </FormGroup>
                    </>
                  )}
                </div>
              )}
            </div>
          </WizardItem>

          {showInsumesStep && (
            <WizardItem id='step3' title='Vincular Insumos'>
              <div className="row  pb-2 d-flex p-2">
                {formik.values?.type_insume?.includes('check') ? (
                  <>
                    <div className='col-md-11'>
                      <div className='d-flex'>
                        {/* Insume */}
                        <FormGroup id='insume' label='Insumo' className='col-md-4 mb-4 px-2'>
                          <Select
                            placeholder='Selecione o insumo'
                            list={noListedInsumes}
                            onChange={(e) => {
                              const id = e.target.value;
                              formik.setFieldValue('insume', id);
                              const findedInsume = noListedInsumes.find((i) => i.value == id)
                              formik.setFieldValue('insume_unit', findedInsume.unit);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.insume}
                          />
                        </FormGroup>

                        {/* Unit */}
                        <FormGroup id='insume_unit' label='Unidade' className='col-md-2 px-2'>
                          <Input
                            placeholder='tipo'
                            value={formik.values.insume_unit}
                            disabled
                            readOnly
                          />
                        </FormGroup>

                        {/* Quantidade Disponível */}
                        <FormGroup id='insume_qtd' label='Quantidade' className='col-md-2 px-2'>
                          <Input
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.insume_qtd}
                            isValid={formik.isValid}
                            isTouched={formik.touched.insume_qtd}
                            invalidFeedback={formik.errors.insume_qtd}
                            validFeedback='Assim está bom!'
                            placeholder='100'
                            type='number'
                          />
                        </FormGroup>
                      </div>
                    </div>
                    {/* Botão de adicionar produto ao Insumo */}
                    <div className='col-md-1'>
                      {checkStepIsValid('add_product') ? (
                        <Popovers desc="Por favor, preencha os campos" placement="right" trigger="hover">
                          <div className='d-flex flex-column justify-content-center align-items-center'>
                            {/* // Não apagar o espaço entre as labels */}
                            <Label>⠀⠀⠀⠀⠀⠀⠀⠀⠀</Label>
                            <Button
                              disabled={checkStepIsValid('add_insumo')}
                              color="light"
                              icon="PlusCircle"
                              shadow="sm"
                              hoverShadow="sm"
                              size="sm"
                              onClick={handleAddInsumeToProduct}
                            />
                          </div>
                        </Popovers>
                      ) : (
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          {/* // Não apagar o espaço entre as labels */}
                          <Label>⠀⠀⠀⠀⠀⠀⠀⠀⠀</Label>
                          <Button
                            disabled={checkStepIsValid('add_insumo')}
                            color="light"
                            icon="PlusCircle"
                            shadow="sm"
                            hoverShadow="sm"
                            size="sm"
                            onClick={handleAddInsumeToProduct}
                          />
                        </div>
                      )}
                    </div>
                    {/* Produtos adicionados */}
                    <div className="col-md-12">
                      {insumeToProduct?.length > 0 && (
                        <h6>Insumos adicionados</h6>
                      )}
                      {insumeToProduct?.map((product, index) => (
                        <div className='d-flex justify-content-center align-items-center py-1' key={index}>
                          <div className='d-flex'>
                            <FormGroup className='col-md-4 px-2'>
                              <Input
                                value={product.name}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                            <FormGroup className='col-md-2 px-2'>
                              <Input
                                value={product.unit}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                            <FormGroup className='col-md-2 px-2'>
                              <Input
                                value={product.isNew ? product.qtd : product.qtd}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                          </div>
                          <div className='d-flex justify-content-center align-items-center px-2'>
                            <Button
                              color="danger"
                              icon="Trash"
                              shadow="sm"
                              hoverShadow="sm"
                              size="sm"
                              onClick={() => handleRemoveInsume(index)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className='row g-4 mt-1'>
                    <h6 className='text-center'>Você deve marcar a opção <b className='text-primary'>"Insumos ?"</b> em <b className='text-primary'>"Informações do Produto"</b> para visualizar esta seção.</h6>
                  </div>
                )}
              </div>
            </WizardItem>
          )}

          {showCompoundStep && (
            <WizardItem id='step4' title='Composição do combo'>
              <div className="row  pb-2 d-flex p-2">
                {formik.values.type_compound.includes('check') ? (
                  <>
                    <div className='col-md-11'>
                      <div className='d-flex'>
                        {/* Produto */}
                        <FormGroup id='product' label='Produto' className='col-md-4 mb-4 px-2'>
                          <Select
                            placeholder='Selecione o produto'
                            list={productsNoComboOption}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.product}
                          // isValid={formik.isValid}
                          // isTouched={formik.touched.product}
                          // invalidFeedback={formik.errors.product}
                          />
                        </FormGroup>

                        {/* Quantidade Disponível */}
                        <FormGroup id='product_qtd' label='Quantidade' className='col-md-2 px-2'>
                          <Input
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.product_qtd?.replace(/\D/g, "")}
                            isValid={formik.isValid}
                            isTouched={formik.touched.product_qtd}
                            invalidFeedback={formik.errors.product_qtd}
                            validFeedback='Assim está bom!'
                            placeholder='100'
                          />
                        </FormGroup>

                        {/* Unit */}
                        <FormGroup id='product_unit' label='Unidade' className='col-md-2 px-2'>
                          <Select
                            placeholder='Selecione o tipo'
                            list={_selectUnit}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.product_unit}
                          // isValid={formik.isValid}
                          // isTouched={formik.touched.product_unit}
                          // invalidFeedback={formik.errors.product_unit}
                          />
                        </FormGroup>

                        {/* Valor por unidade */}
                        <FormGroup id='product_unit_value' label='Valor' className='col-md-2 px-2'>
                          <Input
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={masks.money(formik.values.product_unit_value)}
                            // isValid={formik.isValid}
                            // isTouched={formik.touched.product_unit_value}
                            // invalidFeedback={formik.errors.product_unit_value}
                            // validFeedback='Assim está bom!'
                            placeholder='100'
                          />
                        </FormGroup>
                        <FormGroup className='mx-4' >

                          <Label>Imprimir?</Label>
                          <ChecksGroup
                            isValid={formik.isValid}
                            isTouched={formik.touched.productPrint}
                            invalidFeedback={formik.errors.productPrint}
                            className="mt-2"
                          >
                            <ChecksGroup isInline>
                              <Checks
                                type="switch"
                                id="productPrint"
                                label={formik.values.productPrint ? 'Sim' : 'Não'}
                                name="productPrint"
                                onChange={formik.handleChange}
                                checked={formik.values.productPrint}
                              />
                            </ChecksGroup>
                          </ChecksGroup>
                        </FormGroup>
                      </div>
                    </div>
                    {/* Botão de adicionar produto ao combo */}
                    <div className='col-md-1'>
                      {checkStepIsValid('add_product') ? (
                        <Popovers desc="Por favor, preencha os campos" placement="right" trigger="hover">
                          <div className='d-flex flex-column justify-content-center align-items-center'>
                            {/* // Não apagar o espaço entre as labels */}
                            <Label>⠀⠀⠀⠀⠀⠀⠀⠀⠀</Label>
                            <Button
                              disabled={checkStepIsValid('add_product')}
                              color="light"
                              icon="PlusCircle"
                              shadow="sm"
                              hoverShadow="sm"
                              size="sm"
                              onClick={handleAddProductsToCompound}
                            />
                          </div>
                        </Popovers>
                      ) : (
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          {/* // Não apagar o espaço entre as labels */}
                          <Label>⠀⠀⠀⠀⠀⠀⠀⠀⠀</Label>
                          <Button
                            disabled={checkStepIsValid('add_product')}
                            color="light"
                            icon="PlusCircle"
                            shadow="sm"
                            hoverShadow="sm"
                            size="sm"
                            onClick={handleAddProductsToCompound}
                          />
                        </div>
                      )}
                    </div>
                    {/* Produtos adicionados */}
                    <div className="col-md-12">
                      {productsToCompound.length > 0 && (
                        <h6>Produtos adicionados</h6>
                      )}
                      {productsToCompound.map((product, index) => (
                        <div className='d-flex justify-content-center align-items-center py-1' key={index}>
                          <div className='d-flex'>
                            <FormGroup className='col-md-4 px-2'>
                              <Input
                                value={productDicionary[product.product]?.name}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                            <FormGroup className='col-md-2 px-2'>
                              <Input
                                value={product.qtd}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                            <FormGroup className='col-md-2 px-2'>
                              <Input
                                value={product.unit}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                            <FormGroup className='col-md-2 px-2'>
                              <Input
                                value={Money.centsToMaskMoney(product.unit_value)}
                                disabled
                                readOnly
                              />
                            </FormGroup>

                            <FormGroup className='col-md-2 px-2'>

                              <Icon icon={product.productPrint ? "Print" : "PrintDisabled"} size="3x" />


                            </FormGroup>
                          </div>
                          <div className='d-flex justify-content-center align-items-center px-2'>
                            <Button
                              color="danger"
                              icon="Trash"
                              shadow="sm"
                              hoverShadow="sm"
                              size="sm"
                              onClick={() => handleRemoveProductsToCompound(index)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                  </>
                ) : (
                  <div className='row g-4 mt-1'>
                    <h6 className='text-center'>Você deve marcar a opção <b className='text-primary'>"Produto Composto?"</b> em <b className='text-primary'>"Informações do Produto"</b> para visualizar esta seção.</h6>
                  </div>
                )}
              </div>
            </WizardItem>
          )}

          {showComplementsStep && (
            <WizardItem id='step5' title='Categorias de complementos'>
              <div className="row  pb-2 d-flex">
                {formik.values.category_complements.includes('check') ? (
                  categoryComplementsResponse.length > 0 ? (
                    <>
                      {HeaderComplements}
                      {categoryComplementsResponse.map((categoryComplement, index) => {
                        return (
                          <div className="row g-4 py-2" key={index} style={{ marginTop: 0 }}>
                            <div className='col-md-1' style={{ marginTop: 0 }}>
                              <div className='h-100 d-flex align-items-center justify-content-center' style={{ marginTop: 3, marginRight: 0 }}>
                                <ChecksGroup style={{ marginRight: 0 }}>
                                  <Checks
                                    type="switch"
                                    id="complements"
                                    name="complements"
                                    value={categoryComplement.id}
                                    onChange={formik.handleChange}
                                    checked={formik.values.complements?.includes(categoryComplement.id)}
                                    isInline
                                  />
                                </ChecksGroup>
                              </div>
                            </div>
                            <div className='col-md-3' style={{ marginTop: 0 }}>
                              <FormGroup>
                                <Input
                                  value={categoryComplement.name}
                                  disabled
                                  readOnly
                                />
                              </FormGroup>
                            </div>
                            <div className='col-md-4' style={{ marginTop: 0 }}>
                              <FormGroup>
                                <Input
                                  value={categoryComplement.description}
                                  disabled
                                  readOnly
                                />
                              </FormGroup>
                            </div>
                            <div className='col-md-2' style={{ marginTop: 0 }}>
                              <FormGroup>
                                <Input
                                  value={categoryComplement.min_item?.toString()}
                                  disabled
                                  readOnly
                                />
                              </FormGroup>
                            </div>
                            <div className='col-md-2' style={{ marginTop: 0 }}>
                              <FormGroup>
                                <Input
                                  value={categoryComplement.max_item?.toString()}
                                  disabled
                                  readOnly
                                />
                              </FormGroup>
                            </div>
                          </div>
                        )
                      })}
                    </>
                  ) : (
                    <div className='row g-4 mt-1'>
                      <h6 className='text-center'>Não há complementos cadastrados para este estabelecimento</h6>
                    </div>
                  )
                ) : (
                  <div className='row g-4 mt-1'>
                    <h6 className='text-center'>Você deve marcar a opção <b className='text-primary'>"Complementos?"</b> em <b className='text-primary'>"Informações do Produto"</b> para visualizar esta seção.</h6>
                  </div>
                )}
              </div>
            </WizardItem>
          )}

          <WizardItem id='step6' title='Grupo Fiscal'>
            <div className="row pb-2 d-flex">
              {(Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : []).map((item, index, arr) => {
                const selectedStates = (Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : [])
                  .map((i) => i?.state)
                  .filter(Boolean)
                const stateOptions = _selectBrazilStates.map((opt) => ({
                  ...opt,
                  disabled: selectedStates.includes(opt.value) && opt.value !== (item?.state || ''),
                }))
                const canAdd = [...new Set(selectedStates)].length < _selectBrazilStates.length

                return (
                  <React.Fragment key={`${item?.state || 'state'}-${item?.fiscal_group_id || 'group'}-${index}`}>
                    <FormGroup
                      id={`fiscal_groups_by_state[${index}].state`}
                      label='Estado'
                      className='col-md-6 mb-4'
                    >
                      <Select
                        placeholder='Selecione'
                        value={item?.state || ''}
                        list={stateOptions}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        isValid={formik.isValid}
                        isTouched={formik.submitCount > 0 || formik.touched?.fiscal_groups_by_state?.[index]?.state}
                        invalidFeedback={formik.errors?.fiscal_groups_by_state?.[index]?.state}
                      />
                    </FormGroup>

                    <div className='col-md-6 mb-4'>
                      <div className='d-flex gap-2 align-items-end'>
                        <FormGroup
                          id={`fiscal_groups_by_state[${index}].fiscal_group_id`}
                          label='Grupo Fiscal'
                          className='flex-grow-1 mb-0'
                        >
                          <Select
                            placeholder='Selecione o grupo fiscal'
                            value={item?.fiscal_group_id || ''}
                            list={optionsFiscalGroups}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            isValid={formik.isValid}
                            isTouched={formik.submitCount > 0 || formik.touched?.fiscal_groups_by_state?.[index]?.fiscal_group_id}
                            invalidFeedback={formik.errors?.fiscal_groups_by_state?.[index]?.fiscal_group_id}
                          />
                        </FormGroup>

                        <Button
                          color="danger"
                          icon="Trash"
                          shadow="sm"
                          hoverShadow="sm"
                          size="sm"
                          onClick={() => handleRemoveFiscalGroupByState(index)}
                        />

                        {index === arr.length - 1 && (
                          <Button
                            disabled={!canAdd}
                            color="dark"
                            icon="PlusCircle"
                            shadow="sm"
                            hoverShadow="sm"
                            size="sm"
                            onClick={handleAddFiscalGroupByState}
                          />
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          </WizardItem>

          <WizardItem id='step7' title='Informações Fiscais'>
            <div className="row  pb-2 d-flex">

              {/* Código de barras */}
              <FormGroup id='fiscal_data_bar_code' label='Código de barras' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_bar_code}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_bar_code}
                  invalidFeedback={formik.errors.fiscal_data_bar_code}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 7891234567890'
                  inputMode='numeric'
                />
              </FormGroup>

              {/* NCM */}
              <FormGroup id='fiscal_data_ncm' label='NCM' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_ncm}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_ncm}
                  invalidFeedback={formik.errors.fiscal_data_ncm}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'

                />
              </FormGroup>

              {/* CST */}
              <FormGroup id='fiscal_data_cst' label='CST / ICMS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cst}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cst}
                  invalidFeedback={formik.errors.fiscal_data_cst}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* CSOSN */}
              <FormGroup id='fiscal_data_csosn' label='CSOSN' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_csosn}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_csosn}
                  invalidFeedback={formik.errors.fiscal_data_csosn}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* CEST */}
              <FormGroup id='fiscal_data_cest' label='CEST' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cest}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cest}
                  invalidFeedback={formik.errors.fiscal_data_cest}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* CFOF */}
              <FormGroup id='fiscal_data_cfop' label='CFOP' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cfop}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cfop}
                  invalidFeedback={formik.errors.fiscal_data_cfop}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* <FormGroup id='fiscal_data_sku' label='SKU' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_sku}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_sku}
                  invalidFeedback={formik.errors.fiscal_data_sku}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 12445'
                />
              </FormGroup> */}
              <FormGroup id='fiscal_data_pis' label='PIS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_pis}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_pis}
                  invalidFeedback={formik.errors.fiscal_data_pis}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cofins' label='COFINS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cofins}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cofins}
                  invalidFeedback={formik.errors.fiscal_data_cofins}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cBenef' label='Código de Benefício Fiscal' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cBenef}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cBenef}
                  invalidFeedback={formik.errors.fiscal_data_cBenef}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: RS123456'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cClassTrib' label='Classificação Tributária CBS/IBS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cClassTrib}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cClassTrib}
                  invalidFeedback={formik.errors.fiscal_data_cClassTrib}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 000000'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cst_cbs_ibs' label='CST CBS/IBS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cst_cbs_ibs}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cst_cbs_ibs}
                  invalidFeedback={formik.errors.fiscal_data_cst_cbs_ibs}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 00'
                />
              </FormGroup>


              <FormGroup id='fiscal_data_percentualReducao' label='Redução IBS/CBS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_percentualReducao}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_percentualReducao}
                  invalidFeedback={formik.errors.fiscal_data_percentualReducao}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 40'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_pRedICMS' label='Redução da Base do ICMS (%)' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_pRedICMS}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_pRedICMS}
                  invalidFeedback={formik.errors.fiscal_data_pRedICMS}
                  placeholder='Ex.: 40'
                />
              </FormGroup>



              {
                <>
                  {/* Aliquota ICMS */}
                  <FormGroup id='fiscal_data_aliq_icms' label='Alíquota ICMS' className='col-md-4 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fiscal_data_aliq_icms}
                      isValid={formik.isValid}
                      isTouched={formik.touched.fiscal_data_aliq_icms}
                      invalidFeedback={formik.errors.fiscal_data_aliq_icms}
                      validFeedback='Assim está bom!'
                      placeholder='Ex: 18.00'
                    />
                  </FormGroup>
                </>
              }

            </div>
          </WizardItem>
        </Wizard>
      </ModalBody>
    </Modal >
  )
}

export default memo(ModalRegisterProducts);
